import styled from 'styled-components';

import { glsp } from '@devseed-ui/theme-provider';

const Form = styled.form`
  display: grid;
  grid-template-rows: auto;
  grid-gap: ${glsp()};
`;

export default Form;
